export default __webpack_public_path__ + "static/media/IMG_2351.0ad01d7c.jpeg";